import { LocationDescriptorObject } from 'history'

import { HttpClient } from 'modules/http-client'
import { WebStorage } from 'modules/web-storage'

import { RouterService } from '../core'
import { isString } from '../shared'

import { DEFAULT_REDIRECT, REDIRECT_QUERY_PARAM, STORAGE_KEY } from './constants'
import { User } from './models'

// @URL: http://dev-perfman2-api.hciapp.net/swagger/#/Accounts
const NAMESPACE = 'accounts'

const api = {
  current: () => `${NAMESPACE}/current`,
  logout: () => `${NAMESPACE}/logout`,
  loginAs: () => `${NAMESPACE}/login-as`,
}

export class AuthService {
  constructor(private httpClient: HttpClient, private routerService: RouterService, private webStorage: WebStorage) {}

  private get redirectOrigin() {
    return this.webStorage.get<string>(STORAGE_KEY)
  }

  buildLoginURI(baseHref: string, redirectLocation: LocationDescriptorObject): string {
    const redirectQueryUrl = this.routerService.serializeUrl(redirectLocation)
    const urlForRedirect = `${this.routerService.origin}${redirectQueryUrl}`

    const redirectQuery = this.routerService.serializeUrl(
      {
        search: {
          [REDIRECT_QUERY_PARAM]: urlForRedirect,
        },
      },
      { encodeDeepProps: true, stripLeadingSlash: true }
    )

    return `${baseHref}${redirectQuery}`
  }

  currentUser() {
    return this.httpClient.get<User>(api.current()).then(({ data }) => data)
  }

  logout() {
    this.clearRedirectOrigin()

    return this.httpClient.get<void>(api.logout())
  }

  loginAs(userName: string) {
    return this.httpClient.post<void>(api.loginAs(), null, {
      params: {
        userName,
      },
    })
  }

  hasRedirectOrigin(): boolean {
    return isString(this.redirectOrigin)
  }
  getRedirectOrigin(): string {
    return this.redirectOrigin || DEFAULT_REDIRECT
  }
  clearRedirectOrigin(): void {
    this.webStorage.remove(STORAGE_KEY)
  }
  setRedirectOrigin(originURL: string = this.routerService.url) {
    this.webStorage.set(STORAGE_KEY, originURL)
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.service.ts